import { render } from "./post-smtp-settings.vue?vue&type=template&id=154e6add&scoped=true"
import script from "./post-smtp-settings.vue?vue&type=script&lang=js"
export * from "./post-smtp-settings.vue?vue&type=script&lang=js"

import "./post-smtp-settings.vue?vue&type=style&index=0&id=154e6add&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154e6add"],['__file',"src/components/post-smtp-settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "154e6add"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('154e6add', __exports__)) {
    api.reload('154e6add', __exports__)
  }
  
  module.hot.accept("./post-smtp-settings.vue?vue&type=template&id=154e6add&scoped=true", () => {
    api.rerender('154e6add', render)
  })

}


export default __exports__